import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { environment } from './../../environments/environment';

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);
  private toasterService = inject(ToastrService);
  private logger = inject(NGXLogger);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Add Authorization header with Access Token if user is logged in and request is to /api/*
    const isApiUrl = request.url.startsWith(environment.api);
    if (this.authService.isAuthenticated && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.accessToken}`
        }
      });
    }
    return next.handle(request).pipe(
      tap(
        () => { },
        error => {
          if (error instanceof HttpErrorResponse) {
            if (error.url.includes('/api/')) {
              this.toasterService.error(error.message, 'We had a problem', {
                 closeButton: true,
                //  disableTimeOut: true
              });
              this.logger.error(`API Request failed. Toast error displayed: "${error.message}". ${JSON.stringify({
                status: error.status,
                url: error.url,
              })}`);
            } else {
              this.logger.error(`Page Request failed: "${error.message}". ${JSON.stringify({
                status: error.status,
                url: error.url,
              })}`);
            }
          }
        }
      ));
  }
}
